import gql from "graphql-tag.macro";
import { ONE_SECOND } from "Globals/constants/constants";

const settingsListFragment = gql`
    fragment SettingsList on NotificationSetting {
        EMAIL_DIGEST,
        DOCUMENT_ALL_INAPP,
        DOCUMENT_ALL_EMAIL,
        SECURITY_ALL_EMAIL,
        COMMENT_ALL_INAPP,
        COMMENT_ALL_EMAIL,
        DOCUMENT_ASSIGNED,
        DOCUMENT_WORKFLOW_CHANGE,
        HEADING_ASSIGNED,
        HEADING_WORKFLOW_CHANGE,
        PROJECT_PUBLISHED_TP,
        COMMENT_OWNED_HEADING,
        COMMENT_REPLY,
        COMMENT_ON_ASSIGNED_TO 
    }
`;

const query = gql`
query projectNotificationSettings {
    me {
        _id
        projectNotificationSetting {
          ... on NotificationSetting {
            ...SettingsList
          }
        }
      }
}
${settingsListFragment}    
`;

const mutationQuery = gql`
    mutation updateProjectNotificationSettings(
        $notificationSettings: NotificationSettingInput
    ) {
        updateProjectNotificationSettings(notificationSettings: $notificationSettings) {
            _id
            ...SettingsList
        }
    }
${settingsListFragment}    
    `;

const subscriptionQuery = gql`
    subscription subscribeProjectNotificationSetting {
        subscribeProjectNotificationSetting {
            _id
            ...SettingsList  
        }
    }
${settingsListFragment}    
`;

export const loadNotificationSettings = async ({ client }) => {
    const { data: { me: { projectNotificationSetting } } } = await client.query({ query, fetchPolicy: "no-cache" });
    return projectNotificationSetting;
};

const mockSubscribeNotificationSettings = ({ emitter }, { client }) => {
    setTimeout(async () => {
        emitter(await loadNotificationSettings({ client }));
    }, ONE_SECOND);
    return () => null;
};

export const subscribeNotificationSettings = (window?.app?.config?.v3MockApiEnabled || process.env.STORYBOOK_IS_STORYBOOK)
    ? mockSubscribeNotificationSettings
    : ({ subject, emitter }, { client }) => {
        const observable = client.subscribe({
            query: subscriptionQuery,
            variables: { payload: { user: subject } },
        });
        const subscription = observable.subscribe(val => emitter(val));
        return () => subscription.unsubscribe;
    };

export const updateNotificationSettings = ({ notificationSettings }, { client }) =>
    client.mutate({
        mutation: mutationQuery,
        variables: { notificationSettings },
    });
